import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-kyc-high-risk-dialog',
  templateUrl: './kyc-high-risk-dialog.component.html',
  styleUrls: ['./kyc-high-risk-dialog.component.scss']
})
export class KycHighRiskDialogComponent {
  constructor(
    private matDialog: MatDialog,
    private router: Router,
    public languageService: LanguageService,
  ) { }
  close() {
    this.matDialog.closeAll();
  }
  goToKyc() {
    this.close();
    this.router.navigate(['/kyc/kyc-questions']);
  }
}
